/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { useQuery } from 'react-query'

import commentsLogService from './commentsLog.service'

type Props = {
  externalEntityId?: string
}

export function useCommentsLogByEntityIdQuery({ externalEntityId }: Props) {
  return useQuery({
    queryFn: () =>
      commentsLogService.getListByExternalEntityId(externalEntityId!),
    enabled: !!externalEntityId,
    queryKey: ['comments', 'byEntityId', externalEntityId],
  })
}
